module.exports = __webpack_public_path__ + "img/qbc-exhibitors.6dabdaa3.png";